export const SEND_EMAIL_CHOICE_STATUSES = {
    ANSWERED: 'answered',
    UNANSWERED: 'unanswered',
} as const;

export const SEND_EMAIL_CHOICE_ACTIONS = {
    CHOSEN: 'chosen',
    MISSING_ON_SAVE: 'missingOnSave',
    RESET: 'reset',
} as const;
